import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from './toast.service';

@Component({
  selector: 'app-toasts',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="toast-container">
      <div *ngFor="let toast of toastService.toasts()" class="toast" [ngClass]="toast.type">
        {{ toast.message }}
        <button class="close-btn" (click)="toastService.remove(toast.id)">×</button>
      </div>
    </div>
  `,
  styles: [
    `
      .toast-container {
        position: fixed;
        bottom: 1.5rem;
        right: 1.5rem;
        z-index: 9999;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        pointer-events: none;
      }
      .toast {
        pointer-events: auto;
        padding: 1rem 1.5rem;
        border-radius: 8px;
        color: white;
        font-weight: 500;
        font-size: 0.95rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        animation: slideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        min-width: 250px;
      }
      .toast.success {
        background-color: #10b981;
      }
      .toast.error {
        background-color: #ef4444;
      }
      .toast.info {
        background-color: #3b82f6;
      }
      .close-btn {
        background: none;
        border: none;
        color: white;
        cursor: pointer;
        font-size: 1.25rem;
        line-height: 1;
        opacity: 0.8;
        &:hover {
          opacity: 1;
        }
      }
      @keyframes slideIn {
        from {
          transform: translateX(100%);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
    `,
  ],
})
export class ToastComponent {
  toastService = inject(ToastService);
}
